<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-col  class="text-center">
              <h2 class="font-weight-light:999  display-1">联系我们</h2>
              <h1 class="font-weight-light:999  display-1 custom-text-color" >Contact</h1>
            </v-col>
          <v-row justify="center" >
            <v-col cols="12" sm="5">
              
                <div class="flex-center">
                  
                  <img class="img-qrcode " src="@/assets/img/qrcode.jpg"/>
                </div>
            
              <h3 class="font-weight-light text-center padding-bottom-10" >
                <span style="font-weight: 999;">

                  企业公众号
                </span>
              </h3>
              <br>
              <h3 class="font-weight-light text-center">
              商务合作热线：<span style="font-weight: 999;">0574-87612060</span>
              </h3>
              <h3 class="font-weight-light text-center">
              技术服务热线：<span style="font-weight: 999;">0574-87612080</span>
              </h3>
              <h3 class="font-weight-light text-center">
              <!-- <h3 class="font-weight-light text-center"> -->
                邮箱：<span style="font-weight: 999;">service@universalstar.cn</span>
              </h3>
              <br>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
    <!-- <v-snackbar
        v-model="snackbar.enabled"
        timeout="3000"
        right
        top
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.enabled = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar> -->
  </section>
</template>

<style scoped>
.text-center{
 font-size: 14px;
 line-height: 2em;
 
}
/* #contact {
  background-color: #f4f7f5;
} */

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
.img-qrcode{
  height: 200px;
  width: 200px;
   display: flex;
  align-items: center;
  justify-content: center;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

<script>
// import {db} from '@/main'

export default {
  // data: () => ({
  //   icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
  //   valid: true,
  //   name: "",
  //   nameRules: [
  //     (v) => !!v || "The name field is required",
  //     (v) => (v && v.length >= 6) || "The name must be longer than 6 characters",
  //   ],
  //   email: "",
  //   emailRules: [
  //     (v) => !!v || "The email field is mandatory",
  //     (v) => /.+@.+\..+/.test(v) || "Email must be valid",
  //   ],
  //   textArea: "",
  //   textAreaRules: [
  //     (v) => !!v || "The text field is required",
  //     (v) => (v && v.length >= 10) || "Minimum 10 characters",
  //   ],
  //   lazy: false,
  //   snackbar: {
  //     enabled: false,
  //     text: '',
  //     color: ''
  //   }
  // }),
  methods: {
    // submit() {
      /*db.collection("contactData").add({
        name: this.name,
        email: this.email,
        message: this.textArea
      }).then(() => {
        this.snackbar.text = "Mensagem enviada com sucesso"
        this.snackbar.color = "success"
        this.snackbar.enabled = true
      }).catch(() => {
        this.snackbar.text = "Erro ao enviar mensagem"
        this.snackbar.color = "danger"
        this.snackbar.enabled = true
      })*/
    // }
  }
};
</script>
